module.exports = __webpack_public_path__ + "media/customizations/regencyatesperanza/logo-82fea22b4379ee49afe2c971e4cf65c5.png";